(() => {
  class CopyToClipboard extends HTMLElement {
    constructor() {
      super();

      this.textToCopy = this.dataset.copyText;
    }

    connectedCallback() {
      this.button.addEventListener("click", () => this.copyText());
    }

    /**
     * Copies the specified text to the clipboard
     */
    copyText() {
      if (!this.textToCopy) return;

      navigator.clipboard.writeText(this.textToCopy)
        .then(() => console.log('Text copied to clipboard'))
        .catch(error => console.error('Could not copy text: ', error));
    }

    /**
     * @return {HTMLElement} The copy button element
     */
    get button() {
      return this.querySelector("[data-copy-button]");
    }
  }

  if (!customElements.get('copy-to-clipboard')) {
    customElements.define('copy-to-clipboard', CopyToClipboard);
  }
})();